import React from 'react';
import fr from 'facet-rest';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useMFAResetInitiation } from './useMFAResetInitiation';

export const VerifyIdentityButton = () => {
  const { resource } = useMetaLayoutContext();
  const { onClickStartReset, ok } = useMFAResetInitiation(resource, fr.relationships.mfaResetLink.name);

  if (!ok) {
    return null;
  }

  return (
    <FDPrimaryActionButton
      fullWidth
      isFullWidth
      onClick={onClickStartReset}
      label={'Verify Identity'}
    />
  );
};
